import React from 'react'
import './ButtonLeft.css'
import { LeftSvg } from './SVGarr'
import { Link } from 'react-router-dom'

const ButtonLeft = (props) => {
  return(
    <Link to={props.url} className="ButtonLeft">
      {LeftSvg}
    </Link>
  )
}

export default ButtonLeft


// WEBPACK FOOTER //
// ./src/components/ButtonLeft.jsx